import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

type Props = {
  goToDashboard: () => void;
};

class WhatsNextPage extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Text type="h3">All set! Here&apos;s what&apos;s next</Text>
            <Text>
              We will notify your tenant of the new payment request. The payment will remain outstanding until it’s paid
              or you cancel it.
            </Text>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button type="primary" full onClick={this.props.goToDashboard}>
              OK, got it
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default WhatsNextPage;
